import { CurrencyPipe } from "@angular/common";
import { formatProductListDiscount } from "@domain/project/product-list/product-list-discount.util";
import { ProductTableRow } from "@pdf/export-services/product-information-pages/product-list-pages/product-table-row";
import { DefaultRow } from "@pdf/helpers/default-row/default-row";
import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { TableProperties } from "@pdf/pdf-properties";
import { jsPDF } from "jspdf";

export class ProductListProductRow extends DefaultRow {
  readonly position: string;
  readonly quantity: string;
  readonly name: string[];
  readonly id: string;
  readonly priceData: string;
  readonly discount: string;
  readonly totalCosts: string;
  readonly isPlaceholder: boolean;
  readonly showWarning: boolean;

  private currencyPipe: CurrencyPipe;

  constructor(pdf: jsPDF, localeId: string, columns: TableColumn[], productRowData: ProductTableRow) {
    super();
    this.isPlaceholder = productRowData.isPlaceholder;
    this.currencyPipe = new CurrencyPipe(localeId);
    this.position = productRowData.position;
    this.quantity = productRowData.quantity;
    this.name = this.splitText(pdf, columns[2].width, productRowData.name);
    this.id = productRowData.id;
    this.priceData = productRowData.priceData
      ? this.formatCosts(productRowData.priceData.price, localeId, productRowData.priceData.currencyCode)
      : "--";
    this.discount =
      productRowData.priceData && (productRowData.discount ?? 0) > 0
        ? `${this.formatDiscount(productRowData.discount ?? 0, localeId)}%`
        : "--";
    this.totalCosts = productRowData.priceData
      ? this.formatCosts(productRowData.totalCosts, localeId, productRowData.priceData.currencyCode)
      : "--";
    this.showWarning = productRowData.showWarning;
    this._textHeight = this.name.length * TableProperties.TEXT_HEIGHT;
  }

  private formatCosts(costs: number | undefined, localeId: string, currencyCode: string) {
    return this.currencyPipe.transform(costs, currencyCode, "symbol", undefined, localeId) ?? "--";
  }

  private formatDiscount(discount: number, localeId: string) {
    return formatProductListDiscount(discount, localeId);
  }

  private splitText(pdf: jsPDF, width: number, text: string): string[] {
    pdf.setFontSize(TableProperties.TEXT_FONT_SIZE);
    return pdf.splitTextToSize(text, width);
  }
}
